import react from "react";

import bottura1 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_001 Large.jpeg";
import bottura2 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_002 Large.jpeg";
import bottura3 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_003 Large.jpeg";
import bottura4 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_004 Large.jpeg";
import bottura5 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_005 Large.jpeg";
import bottura6 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_006 Large.jpeg";
import bottura7 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_007 Large.jpeg";
import bottura8 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_008 Large.jpeg";
import bottura9 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_009 Large.jpeg";
import bottura10 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_010 Large.jpeg";
import bottura11 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_011 Large.jpeg";
import bottura12 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_012 Large.jpeg";
import bottura13 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_013 Large.jpeg";
import bottura14 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_014 Large.jpeg";
import bottura15 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_015 Large.jpeg";
import bottura16 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_016 Large.jpeg";
import bottura17 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_017 Large.jpeg";
import bottura18 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_018 Large.jpeg";
import bottura19 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_019 Large.jpeg";
import bottura20 from "../images/commercials/bottura/MMAGAZINE_BOTTURA_FINAL_020 Large.jpeg";


const Bottura = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={bottura1} alt="M Magazine - Bottura - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={bottura2} alt="M Magazine - Bottura - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={bottura3} alt="M Magazine - Bottura - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={bottura4} alt="M Magazine - Bottura - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={bottura5} alt="M Magazine - Bottura - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={bottura6} alt="M Magazine - Bottura - Image 6"/>
                </div>
                <div className="single portrait">
                    <img src={bottura7} alt="M Magazine - Bottura - Image 7"/>
                </div>
                <div className="single portrait">
                    <img src={bottura8} alt="M Magazine - Bottura - Image 8"/>
                </div>
                <div className="single portrait">
                    <img src={bottura9} alt="M Magazine - Bottura - Image 9"/>
                </div>
                <div className="single portrait">
                    <img src={bottura10} alt="M Magazine - Bottura - Image 10"/>
                </div>
                <div className="single portrait">
                    <img src={bottura11} alt="M Magazine - Bottura - Image 11"/>
                </div>
                <div className="single portrait">
                    <img src={bottura12} alt="M Magazine - Bottura - Image 12"/>
                </div>
                <div className="single portrait">
                    <img src={bottura13} alt="M Magazine - Bottura - Image 13"/>
                </div>
                <div className="single portrait">
                    <img src={bottura14} alt="M Magazine - Bottura - Image 14"/>
                </div>
                <div className="single portrait">
                    <img src={bottura15} alt="M Magazine - Bottura - Image 15"/>
                </div>
                <div className="single portrait">
                    <img src={bottura16} alt="M Magazine - Bottura - Image 16"/>
                </div>
                <div className="single portrait">
                    <img src={bottura17} alt="M Magazine - Bottura - Image 17"/>
                </div>
                <div className="single portrait">
                    <img src={bottura18} alt="M Magazine - Bottura - Image 18"/>
                </div>
                <div className="single portrait">
                    <img src={bottura19} alt="M Magazine - Bottura - Image 19"/>
                </div>
                <div className="single portrait">
                    <img src={bottura20} alt="M Magazine - Bottura - Image 20"/>
                </div>
            </div>
        </div>
    );
}

export default Bottura;